import { Modal } from "react-bootstrap";
import { IMosaicModal } from "@/interfaces/context/modals";
import { getDifferenceDateBirth } from "@/utils/DateFormats";
import { IoMdClose } from "react-icons/io";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { nameSlug } from "@/utils/Functions/NameSlug";
const LikeIcon = "../../assets/images/icons/like.svg";
const DislikeIcon = "../../assets/images/icons/dislike.svg";
const CommentIcon = "../../assets/images/icons/comment.svg";
export default function MosaicModal({
  show,
  onHide,
  photos,
  gallery,
}: IMosaicModal) {
  const pathname = usePathname();
  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="">
      <Modal.Header className="bg-black relative justify-between px-4">
        <Modal.Title className="text-white">{gallery?.name}</Modal.Title>
        <IoMdClose
          className=" text-white w-10 h-10 cursor-pointer"
          onClick={onHide}
        />
      </Modal.Header>
      <Modal.Body className="bg-black p-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
          {photos.map((photo, index) => {
            const name = nameSlug(photo.name || photo.gallery_name);
            const photoDate = `${photo.year}-${photo.month}-${photo.day}`;
            return (
              <div
                key={index}
                className="relative overflow-hidden rounded-lg shadow-lg bg-gray-800"
              >
                <Link
                  href={`${name}/${photo.year}/${photo._id}`}
                  onClick={onHide}
                >
                  <img
                    src={photo.url}
                    alt={`Mosaic photo ${index}`}
                    className="w-full h-80 object-cover transition-transform duration-300 "
                  />
                </Link>

                <div className=" inset-0 bg-black bg-opacity-50   transition-opacity duration-300 flex flex-col justify-between p-4">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center space-x-2">
                      <img src={LikeIcon} className="w-5 h-5" alt="Like" />
                      <p
                        className="text-white text-xs"
                        style={{ paddingLeft: 5 }}
                      >
                        {photo.likes.length}
                      </p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <img
                        src={DislikeIcon}
                        className="w-5 h-5"
                        alt="Dislike"
                      />
                      <p
                        className="text-white text-xs"
                        style={{ paddingLeft: 5 }}
                      >
                        {photo.dislikes.length}
                      </p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <img
                        src={CommentIcon}
                        className="w-5 h-5"
                        alt="Comment"
                      />
                      <p
                        className="text-white text-xs"
                        style={{ paddingLeft: 5 }}
                      >
                        {photo.comments}
                      </p>
                    </div>
                  </div>
                  <p
                    className="text-white font-bold mt-2"
                    style={{ fontSize: "1.2rem" }}
                  >
                    {photoDate}
                  </p>
                  {gallery && (
                    <p
                      className="text-white font-bold mt-2"
                      style={{ fontSize: "1.2rem" }}
                    >
                      {getDifferenceDateBirth(photoDate, gallery!.dateStart)}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
}
